import { GeistProvider, CssBaseline, Themes } from '@geist-ui/core';
import { Toaster } from 'react-hot-toast';
import Router from './routes';
import roLocale from 'date-fns/locale/ro';
import { registerLocale } from 'react-datepicker';
import 'moment/locale/ro';
import CookieConsentBanner from './components/CookieConsentBanner';
import ScrollToTop from './components/ScrollToTop';


registerLocale('ro', roLocale);

const myTheme = Themes.createFromLight({
  type: 'theme',
  breakpoints: {
    xs: { min: '0px', max: '599px' },
    sm: { min: '600px', max: '979px' },
    md: { min: '980px', max: '1279px' },
    lg: { min: '1280px', max: '1920px' },
  },
});

function App() {
  return (
    <GeistProvider themes={[myTheme]} themeType="theme">
      <CssBaseline />
      <Router />
      <CookieConsentBanner />
      <ScrollToTop />
      <Toaster position="top-right" />
    </GeistProvider>
  );
}

export default App;